import { render, staticRenderFns } from "./PortalAccountMenu.vue?vue&type=template&id=089ee87a&scoped=true"
import script from "./PortalAccountMenu.vue?vue&type=script&lang=js"
export * from "./PortalAccountMenu.vue?vue&type=script&lang=js"
import style0 from "./PortalAccountMenu.vue?vue&type=style&index=0&id=089ee87a&prod&scoped=true&lang=css"
import style1 from "./PortalAccountMenu.vue?vue&type=style&index=1&id=089ee87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089ee87a",
  null
  
)

export default component.exports